
import type { IconProps } from 'src/types/icons';

const PausedIcon = (props: IconProps) => (
  <svg {...props} width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.43457" y="1.47949" width="2.72358" height="8.67056" rx="1.36179" stroke="white" strokeWidth="1.5" />
    <rect x="7.34131" y="1.47949" width="2.72358" height="8.67056" rx="1.36179" stroke="white" strokeWidth="1.5" />
  </svg>
);
export default PausedIcon;
